module.exports = __webpack_public_path__ + "img/impactoI1.fe368102.png";